import styled from "@emotion/styled";
import {
  useObservable,
  useObservableState,
  useSubscription,
} from "observable-hooks";
import { useEffect, useState } from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { animated, useSpring } from "react-spring";
import { useHover } from "react-use-gesture";
import { useNotesOperations } from "./state/state/store";
import {
  drag$,
  dragEnds$,
  draggedNote$,
  isDragging$,
  lastDraggedNoteId$,
} from "./view/drag/Control";

const HEIGHT = 0;

const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  height: ${HEIGHT}px;
  display: flex;
  z-index: 300;
  transform: translate3d(0, 0, 10px);
`;

const DropActionContainer = styled.div`
  border-radius: 100px;
  height: 100px;
  width: 100px;
  display: flex;
  background-color: rgba(21, 101, 192, 1);
  color: white;
  padding: 20px;
  transition: background-color, 1s;
  margin: auto;

  &:hover {
    background-color: red;
  }
`;

export const DropActionMenu = () => {
  const lastDraggedNoteId = useObservableState(lastDraggedNoteId$);
  const isDraggin$ = useObservable(() => isDragging$);
  const isDragging = useObservableState(isDraggin$);
  const notesOperations = useNotesOperations();
  const [active, setActive] = useState(false);
  const hoverBind = useHover((state) => {
    setActive(state.hovering);
  });

  const [{ y }, api] = useSpring(() => ({ y: HEIGHT }));

  useSubscription(dragEnds$, () => {
    if (active) {
      drag$.next({ type: "DONE_ANIMATING", id: lastDraggedNoteId! }); // DUMB, should not be here. Only case where there is no animation
      notesOperations.removeNote(lastDraggedNoteId!);
    }
  });

  useEffect(() => {
    if (isDragging) {
      api.start({ y: 0 });
    } else {
      api.start({ y: HEIGHT });
    }
  }, [isDragging, api]);

  return (
    <animated.div style={{ y }}>
      <Wrapper>
        <DropActionContainer {...hoverBind()}>
          <RiDeleteBin5Line style={{ fontSize: "3em", margin: "auto" }} />
        </DropActionContainer>
      </Wrapper>
    </animated.div>
  );
};
